import { useState, useEffect } from 'react'
import axios from 'axios'
import { API_BASE_URL } from '../config/api'
import { useAsyncQuery } from './useAsyncQuery'

export const useEventFetcher = (eventId) => {
  const [event, setEvent] = useState(null)

  const fetchEvent = async () => {
    const response = await axios.get(`${API_BASE_URL}/api/events/${eventId}`, {
      withCredentials: true
    })
    return response.data
  }

  const { data: fetchedEvent, loading, error, refetch } = useAsyncQuery(
    fetchEvent,
    [eventId],
    { enabled: !!eventId, initialData: null }
  )

  // Sync local state with fetched data
  useEffect(() => {
    if (fetchedEvent) {
      setEvent(fetchedEvent)
    }
  }, [fetchedEvent])

  return { event, setEvent, loading, error, refetch }
}
